import { createFileRoute, redirect } from '@tanstack/react-router';
import { sessionQueryOptions } from '@entities/session';
import { LoginPage } from '@pages/login';
import { PageTransition } from '@ui';

export const Route = createFileRoute('/login')({
  // `reason` carries WHY the `_authenticated` guard bounced the user here (currently only
  // 'pro_required' — a lapsed/cancelled Pro subscription) so LoginPage can show the right banner.
  // Genuinely OPTIONAL (not just possibly-undefined) so every other `redirect({ to: '/login' })`
  // in the app — this file's own included — keeps working without passing `search` at all.
  validateSearch: (search: Record<string, unknown>): { reason?: 'pro_required' } => ({
    ...(search.reason === 'pro_required' ? { reason: 'pro_required' } : {}),
  }),
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(sessionQueryOptions).catch(() => null);
    if (user) throw redirect({ to: '/' });
  },
  component: LoginRoute,
});

function LoginRoute() {
  return (
    <PageTransition>
      <LoginPage />
    </PageTransition>
  );
}
